<template>
  <v-footer
    tile
    height="54"
    class="font-weight-medium shadow-sm ma-4 rounded-lg"
    :color="$vuetify.theme.dark ? 'dark' : 'white'"
    :dark="$vuetify.theme.dark"
    :inset="true"
  >
    <div class="d-flex align-center gap-2">
      <v-chip v-if="config.opMode" color="warning" label small>
        Modo técnico
      </v-chip>
      <template v-if="!hidePoweredBy">
        <img
          v-if="$vuetify.theme.dark"
          height="18"
          alt="TiqOne Logo"
          src="/img/logo/tiqone-dark.png"
          class="unselectable non-draggable"
        />
        <img
          v-else
          height="18"
          alt="TiqOne Logo"
          class="unselectable non-draggable"
          src="/img/logo/tiqone-light.png"
        />
      </template>

    </div>
    <v-spacer />
    <v-alert
      @click="$root.$emit('open-support-dialog')"
      style="cursor: pointer"
      dense
      class="mb-0 py-1 text-12"
      color="primary"
      text
    >
      Suporte
    </v-alert>
    <support-dialog />
  </v-footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SupportDialog from "@/components/global/SupportDialog.vue";
import { email, hidePoweredBy } from "@/themeConfig.js";

export default {
  components: {
    SupportDialog,
  },
  data: () => ({
    email,
    hidePoweredBy,
    supportDialog: false,
  }),
  methods: {
    sendEmail(email) {
      window.open(`mailto:${email}`, "_blank");
    },
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
    ...mapGetters("auth", ["config"]),
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("auth", ["hasPermission"]),
  },
};
</script>
